declare global {
  interface Window {
    /**
     * Optional control-panel dev branch identifier (e.g. `feature_OLB-M1-M2`).
     * When set, admin-panel SSO redirects are routed through this branch by
     * injecting the branch as the first path segment.
     */
    devCPBranch?: string;
  }
}

/**
 * Apply the `window.devCPBranch` dev-branch prefix to a control-panel SSO URL.
 *
 * When `window.devCPBranch` is set, the branch is injected as the first path
 * segment and a trailing slash is ensured before the query string, so
 * `https://host/partner/autoLogin?jwt=...` becomes
 * `https://host/<branch>/partner/autoLogin/?jwt=...`.
 *
 * Returns the URL unchanged when `devCPBranch` is unset/blank, or when the input
 * is not a parseable absolute URL.
 */
export const applyDevCpBranch = (ssoUrl: string): string => {
  const branch = window.devCPBranch?.trim();
  if (!ssoUrl || !branch) {
    return ssoUrl;
  }

  try {
    const url = new URL(ssoUrl);
    const path = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`;
    url.pathname = `/${branch}${path}`;
    return url.toString();
  } catch {
    return ssoUrl;
  }
};
